import React from "react";
import { GeneratorParams } from "./fixtures/generator";

import "./DemoOverlay.css";

interface Props {
    name: string;
    params: GeneratorParams;
}

const DemoOverlay: React.FC<Props> = function ({ name, params }: Props) {
    return (
        <div className="demo_overlay">
            <div className="demo_overlay__content">Demo: {name}, view: {params.mondaySettings.view}</div>
        </div>
    );
};

export default DemoOverlay;
